import { ScreenKey } from '@/Enums/Screens/ScreenKey.enum';
import { HEADER_HEIGHT } from '@/constants/layout';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import LoadingIndicator from './LoadingIndicator';

const CampaignSubmission = () => {
  const [loading, setLoading] = useState(true);
  const { menuLinks, loading: meLoading } = useSelector(state => state.me);

  const height = `calc(100vh - ${HEADER_HEIGHT}px)`;

  if (meLoading) {
    return <LoadingIndicator height={height} />;
  }

  const campaignSubmissionUrl = menuLinks?.find(link => ScreenKey[link.label])?.link;

  return (
    <>
      <iframe
        onLoad={() => setLoading(false)}
        className='w-full'
        style={{ height: loading ? '0' : height }}
        src={campaignSubmissionUrl}
      />
      {loading ? <LoadingIndicator height={height} /> : null}
    </>
  );
};

export default CampaignSubmission;
